import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useEditAdminDNCMutation } from "@/redux/services/adminDncApi"
import { setToast } from "@/redux/toastSlice"

export const useAdminEditDNC = () => {
  const dispatch = useAppDispatch()
  const [editAdminDNC, response] = useEditAdminDNCMutation()

  const handleEditAdminDNC = async (body: { id: string; value: string }) => {
    try {
      const response = await editAdminDNC(body).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success edit contact",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { editAdminDNC: handleEditAdminDNC, response }
}
